import {
	reInfoOrgTypeConstants
}from './constants'
import actions from '../../../actions'

const initialState =
{
	isSending  : false,
	paged      : {},
	list       : [],
	changed    : null,
	pagedAudit : null,
	countAudit : null
}

export default function (state = initialState, action){
	switch (action.type){
		case reInfoOrgTypeConstants.GetPaged.REQUEST:
		case reInfoOrgTypeConstants.GetPagedAudit.REQUEST:
		case reInfoOrgTypeConstants.GetPagedAll.REQUEST:
		case reInfoOrgTypeConstants.GetList.REQUEST:
		case reInfoOrgTypeConstants.Create.REQUEST:
		case reInfoOrgTypeConstants.Delete.REQUEST:
		case reInfoOrgTypeConstants.Restore.REQUEST:
		case reInfoOrgTypeConstants.Update.REQUEST:
			return {
				...state,
				isSending : true,
				changed   : null
			}
		case reInfoOrgTypeConstants.GetPaged.FAILURE:
		case reInfoOrgTypeConstants.GetPagedAudit.FAILURE:
		case reInfoOrgTypeConstants.GetPagedAll.FAILURE:
		case reInfoOrgTypeConstants.GetList.FAILURE:
		case reInfoOrgTypeConstants.Create.FAILURE:
		case reInfoOrgTypeConstants.Delete.FAILURE:
		case reInfoOrgTypeConstants.Restore.FAILURE:
		case reInfoOrgTypeConstants.Update.FAILURE:
			return {
				...state,
				isSending : false,
				error     : action.payload,
				changed   : null
			}
		case reInfoOrgTypeConstants.GetPaged.SUCCESS:
		case reInfoOrgTypeConstants.GetPagedAll.SUCCESS:
			return {
				...state,
				isSending : false,
				paged     : action.payload.result
			}
		case reInfoOrgTypeConstants.GetPagedAudit.SUCCESS:
			return {
				...state,
				isSending  : false,
				pagedAudit : action.payload.result.items,
				countAudit : action.payload.result.count
			}
		case reInfoOrgTypeConstants.GetList.SUCCESS:
			return {
				...state,
				isSending : false,
				list      : action.payload.result
			}
		case reInfoOrgTypeConstants.Create.SUCCESS:
			return {
				...state,
				isSending : false,
				changed   : action.payload.result ? actions.create : null
			}
		case reInfoOrgTypeConstants.Delete.SUCCESS:
			return {
				...state,
				isSending : false,
				changed   : action.payload.result ? actions.delete : null
			}
		case reInfoOrgTypeConstants.Update.SUCCESS:
			return {
				...state,
				isSending : false,
				changed   : action.payload.result ? actions.update : null
			}
		case reInfoOrgTypeConstants.Restore.SUCCESS:
			return {
				...state,
				isSending : false,
				changed   : action.payload.result ? actions.restore : null
			}
		case reInfoOrgTypeConstants.CLEAR:
			return {
				...state,
				changed    : null,
				isSending  : false,
				paged      : {},
				list       : [],
				countAudit : null,
				pagedAudit : null
			}
		default:
			return state
	}
}